module.exports = __webpack_public_path__ + "img/icomoon.deaffef8.svg";